$(document).ready(function(){
	
	$('ul.product__links li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.product__links li').removeClass('current');
		$('.tab-content').removeClass('current');
      

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
    
    $('.product__panel__close').on('click',function(){
      $('.product__panel').removeClass('current')
      $('.product__links').css('opacity',1);
    });

  
  
  $(".product__size-guide").click(function(){
    $(".sizeguide_content").addClass("current");
    $('.product__links').css('opacity',0);
  });

  
})


$('.product__gallery__imgs_mobile ').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});
		


$(".product__links li").click(function(){
  $("body").addClass("intro_close");
});

$(".product__panel__close").click(function(){
  $("body").removeClass("intro_close");
});




$(".product__size-guide").click(function(){
  $("body").addClass("intro_close");
});

$(".product__panel__close").click(function(){
  $("body").removeClass("intro_close");
});